import { useState } from "react";
import { Drawer, DatePicker, Input, Button } from "antd";
import { PhoneOutlined, ClockCircleOutlined, TeamOutlined, CheckOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons";

const ReservationsDrawer = ({
  drawerOpen,
  setDrawerOpen,
  reservationList,
  handleReservationCheckIn,
}) => {
  const [searchText, setSearchText] = useState("");
  const [filterDate, setFilterDate] = useState(null);

  const filteredReservations = reservationList.filter((res) => {
    let matchSearch = true;
    let matchDate = true;

    if (searchText.trim()) {
      matchSearch =
        res.name.toLowerCase().includes(searchText.toLowerCase()) ||
        res.phone.includes(searchText);
    }

    if (filterDate) {
      matchDate = res.date === filterDate.format("DD-MM-YYYY");
    }

    return matchSearch && matchDate;
  });

  return (
    <Drawer
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      width="80%"
      styles={{ mask: { backgroundColor: "rgba(0, 0, 0, 0.3)" } }}
      styles={{ body: { padding: "25px 40px", background: "#FFFFFF" } }}
      styles={{ header: { display: "none" } }}
    >
      <div
        style={{
          position: "absolute",
          right: 20,
          top: 20,
          cursor: "pointer",
          fontSize: 20,
          color: "#444",
        }}
        onClick={() => setDrawerOpen(false)}
      >
        <CloseOutlined />
      </div>

      <h1 style={{ fontSize: "25px", fontWeight: 600, marginBottom: 20 }}>Reservations</h1>

      <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
        <DatePicker
          size="large"
          style={{ width: "250px", height: 35, borderRadius: 10, padding: "8px 10px" }}
          format="DD-MM-YYYY"
          value={filterDate}
          onChange={(v) => setFilterDate(v)}
        />
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search by name or phone..."
          size="large"
          style={{ borderRadius: 10, height: 35, flex: 1 }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: "10px" }}>
        {filteredReservations.length === 0 ? (
          <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>No reservations found</p>
        ) : (
          filteredReservations.map((res, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #E5E7EB",
                padding: "20px",
                borderRadius: 12,
                marginBottom: 20,
                display: res.status === "CL" ? "none" : "",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontSize: "15px", fontWeight: 500 }}>{res.name}</span>
                    <span
                      style={{
                        background: res.status === "confirmed" ? "#C7F9CC" : "#FFE8A3",
                        color: "#333",
                        padding: "2px 10px",
                        fontSize: "13px",
                        borderRadius: 8,
                      }}
                    >
                      {res.status}
                    </span>
                  </div>
                  <div style={{ marginTop: 8, display: "flex", gap: 25 }}>
                    <span><PhoneOutlined /> {res.phone}</span>
                    <span><ClockCircleOutlined /> {res.time}</span>
                    <span><TeamOutlined /> {res.guests} guests</span>
                  </div>
                </div>
                <div
                  style={{
                    display: res.status === "OCU" ? "none" : "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <Button
                    icon={<CheckOutlined />}
                    style={{
                      background: "#2F3856",
                      color: "#fff",
                      borderRadius: 10,
                      padding: "0 18px",
                      height: 40,
                    }}
                    onClick={() => handleReservationCheckIn(res)}
                  >
                    Check In
                  </Button>
                  <Button
                    icon={<CloseOutlined />}
                    style={{ borderRadius: 10, padding: "0 18px", height: 40 }}
                  >
                    No Show
                  </Button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </Drawer>
  );
};

export default ReservationsDrawer;
